<div>
    <page-status [pageState]="_pageState"></page-status>
</div>

<h4>Historical Publications</h4>

<div *ngIf="isStaff() && !_data.isEditingFiles" style="margin-bottom: 24px;">
    <button type="button" class="btn btn-sm btn-primary"  style="font-size: 14px;" (click)="onEditFiles()">Add/Edit Material Files</button>
</div>

<div *ngIf="_pageState.isLoaded && !_data.isEditingFiles" style="margin-right: 30px">
    <div class="panel-body">
        <div *ngIf="_summaries && _summaries.length">
            <div *ngFor="let s of _summaries">
                <div class="row publication-margin">
                    <label class="bold col-md-3 publication-title">Expert Panel Summary:</label>
                    <div class="bold col-md-5 publication-title"><a (click)="linkToSummary(s)">{{s.narrativeTitle || s.narrativeLink}}</a></div>
                </div>
            </div>
        </div>

        <div *ngIf="_fmr" class="row publication-margin">
            <label class="bold col-md-3 publication-title">Fragrance Material Review:</label>
            <div class="bold col-md-5 publication-title"><a (click)="linkToFmr()"><span [htmlGreek]="_material.principalSynonym().synonymWordOrWebVersion()"></span></a></div>
        </div>

        <div *ngIf="_hasMonographFiles">
            <div *ngFor="let m of materialMonographFiles; let ix=index">
                <div class="row publication-margin">
                    <label class="bold col-md-3 publication-title">RIFM Monograph:</label>
                    <div class="bold col-md-5 publication-title"><a (click)="linkToMonographFile(m)">{{m.fileLabel}}</a></div>
                </div>
            </div>
        </div>

    </div>
</div>

<div *ngIf="_data.isEditingFiles">
    <material-file-manager></material-file-manager>
</div>
